import API from '@/services/API'
import Armazenamento from '@/services/Armazenamento'
import Compartilhamento from '@/services/Compartilhamento'

const valor = () => API.assinatura.valor()

const maxSimulacoesGratis = 5
const maxSimulacoesVencida = 3
const atualizar = () => buscar(true)

const buscar = (atualizarCache = false) => {
  const cacheUsuario = Armazenamento.usuario.pegar()
  const cacheAssinatura = Armazenamento.assinatura.pegar()

  if (cacheUsuario === null && cacheAssinatura === null) {
    // deslogado
    return Promise.resolve()
  }
  if (!cacheAssinatura || cacheAssinatura.expirado || atualizarCache) {
    return API.assinatura.buscar(cacheUsuario.valor.usuario.id)
      .then(response => {
        if (response.status === 200 && response.data) {
          Armazenamento.assinatura.gravar(response.data)
          validar(response.data)
          return response.data
        }
        validar(null)
        return null
      })
  } else {
    validar(cacheAssinatura.valor)
    return Promise.resolve(cacheAssinatura.valor)
  }
}

const validar = (assinatura) => {
  const cacheSimulacoes = Armazenamento.quantidadeSimulacoes.pegar()
  if (!assinatura) {
    const restante = cacheSimulacoes ? maxSimulacoesGratis - cacheSimulacoes.valor.quantidade : maxSimulacoesGratis
    Compartilhamento.assinatura.gratis(maxSimulacoesGratis, restante)
  } else if (assinatura.status === 'pendente' && assinatura.expiraEm) {
    Compartilhamento.assinatura.pendente2(assinatura.expiraEm)
  } else if (assinatura.status === 'pendente') {
    const restante = cacheSimulacoes ? maxSimulacoesGratis - cacheSimulacoes.valor.quantidade : maxSimulacoesGratis
    Compartilhamento.assinatura.pendente(restante)
  } else if (assinatura.status === 'pago') {
    Compartilhamento.assinatura.ativo()
  } else if (assinatura.status === 'desativado') {
    Compartilhamento.assinatura.desativado()
  } else if (assinatura.status == 'vencida') {
    const restante = cacheSimulacoes ? maxSimulacoesVencida - cacheSimulacoes.valor.quantidade : maxSimulacoesVencida
    Compartilhamento.assinatura.vencida(restante) 
  }
}

export default {
  atualizar,
  buscar,
  validar,
  valor
}



// WEBPACK FOOTER //
// ./src/services/Assinatura.js